import { render, staticRenderFns } from "./fidelior-resources.vue?vue&type=template&id=1739b6ec&"
import script from "./fidelior-resources.vue?vue&type=script&lang=js&"
export * from "./fidelior-resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports